<template>
    <div class="tu-table" v-loading="loading"  element-loading-text="拼命加载中">
        
        <el-row class="tu-table__header">
            <el-col v-for="(item,i) in columns" :key="i" :span="item.span" :style="`text-align:${ item.align }`">
                <el-checkbox v-if="item.type === 'checkbox'" :indeterminate="isIndeterminate" v-model="checked" @change="handleCheckAll($event,true)" class="tu-check_all">全选</el-checkbox>
                <div class="cell" v-else>{{ item.label }}</div>
            </el-col>
        </el-row>

        <div class="tu-table_column">
            <el-row class="tu-table_row" v-for="(row,$index) in data" :key="$index">
                <el-col v-for="(item,i) in columns" :key="i" :span="item.span">
                    <div class="cell" v-if="item.type === 'checkbox'">
                        <el-checkbox ref="checkEle" @change="checkedBox($event, row, $index)"></el-checkbox>
                    </div>
                    <div class="cell" v-else>
                        <el-slot v-if="item.render" :render="item.render" :row="row" :index="$index" :column="item"/>
                        <span v-else>{{ row[item.prop] }}</span>
                    </div>
                </el-col>
            </el-row>
            <div v-if="data.length === 0" class="tu-table__empty-block">暂无数据</div>
        </div>

        <!-- 分页 -->
        <kt-pag
            :currentPage="params.page"
            :pageCount="total"
            :limit="params.limit"
            @onChange="handleChange"
            :pageSizeList="pageSizeList"
        >
        </kt-pag>

    </div>
</template>

<script>
import KtPag from './KtPag'
let elSlot = {
    functional: true,
    props: {
        row: Object,
        render: Function,
        index: Number,
        column: {
            type: Object,
            default: null
        }
    },
    render: (h, data) => {
        const params = {
            row: data.props.row,
            index: data.props.index
        }
        if (data.props.column) params.column = data.props.column
        return data.props.render(h, params)
    }
}
export default {
    props:{
        intApi: Function, //请求接口
        columns: Array, //显示列
        loadingData: { //表格加载
            type: Boolean,
            default: false
        },
        params: { //请求接口参数
            type: Object,
            default(){
                return {}
            }
        },
        pageSizeList: { //页码数值
            type: Array,
            default(){
                return [10, 20, 50, 100]
            }
        },
        dataKey: {
            type: String,
            default: 'rows'
        },
        totalKey: {
            type: String,
            default: 'count'
        }
    },
    components:{
        elSlot,
        KtPag
    },
    data() {
        return {
            data: [], //表格数据
            loading: false,
            checkedRow: [],
            checked: false,
            isIndeterminate: false,
            total: 0
        }
    },
    methods:{
        //获取数据
        async handleList(params){
            try {
                let api = this.intApi
                if(typeof api !== 'function') return console.error(new Error('this is intApi not a function'))
                this.loading = true
                const { status, message, data } = await api(params)
                status === '0' ? null : this.$message({ type: 'error', message, showClose: true })
                if(status === '0'){
                    this.data = data[this.dataKey] || []
                    this.total = data[this.totalKey] || 0
                }
                this.loading = false
            } catch (e) {
                this.loading = false
                this.$message({ message: `数据异常:${e}`, type: 'error', showClose: true })
            }
        },
        //全选
        handleCheckAll: function ($event, isPase = false) {
            if(isPase){
                let arr = this.$refs.checkEle || [];
                arr.forEach(item=>{
                    item.model = $event;
                })
                if($event){
                    let list = [...this.data]
                    this.checkedRow = list;
                }else{
                    this.checkedRow = [];
                }
                this.selectionChange()
                this.isIndeterminate = false
            }
        },
        //单选
        checkedBox: function ($event, row, $index) {
            if($event){
                this.checkedRow.push(row);
            }else{
                this.checkedRow.some((item,i)=>{
                    if(i === $index){
                        this.checkedRow.splice(i,1);
                        return true;
                    }
                    return false
                })
            }
            this.checked = this.checkedRow.length === this.data.length ? true : false;
            this.isIndeterminate = this.checkedRow.length > 0 && this.checkedRow.length < this.data.length
            this.selectionChange()
        },
        //勾选传值
        selectionChange(){
            this.$emit('batchchoice', this.checkedRow);
        },
        handleChange({ page, limit }){
            this.$emit('onChange', { page, limit })
        }
    },
    watch:{
        //分页后重置勾选
        data(){
            this.checked = false;
            this.$nextTick(() => {
                this.handleCheckAll(false,true);
            })
        },
        loadingData: function (val,oldval){
            this.loading = val
        }
    }
}
</script>

<style lang="scss">
    .tu-table{
        position: relative;
        font-size: 12px;
        overflow: hidden;
        box-sizing: border-box;
        div{
            box-sizing: border-box;
        }
        .tu-table__header{
            box-sizing: border-box;
            padding: 12px 0;
            overflow: hidden;
            background-color: #f5f7fa;
            text-align: left;
            .tu-check_all{
                .el-checkbox__label{
                    font-size: 12px;
                    padding-left: 4px;
                }
            }
            .cell{
                padding: 0 6px;
            }
        }
        .tu-table_column{
            position: relative;
            .tu-table_row{
                border-bottom: 1px solid #e9eaec;
                .cell{
                    text-align: left;
                    padding: 6px;
                    line-height: 18px;
                    box-sizing: border-box;
                    white-space: normal;
                    word-break: break-all;
                    text-overflow: ellipsis;
                    p{
                        margin: 0 0 4px 0;
                    }
                    .overflow{
                        letter-spacing: 0;
      			        overflow: hidden;
      			        display: -webkit-box;
      			        text-overflow: ellipsis;
      			        -webkit-line-clamp: 1;  /*要显示的行数*/
      			        -webkit-box-orient: vertical;
                    }
                }
            }
        }
        .tu-table__empty-block{
            text-align: center;
            line-height: 60px;
            // min-height: 60px;
            border-bottom: 1px solid #e9eaec;
            color: #909399;
        }
    }
</style>